import { lazy } from "react";
import { Route } from "react-router-dom";

/**
 * Route de l'INSTALLEUR — SITE_SPEC §8. Vit HORS de <AppLayout> (plein écran, sans header/nav)
 * et n'est pas soumise à l'installer-guard (c'est sa destination). Une fois installé, le BFF
 * renvoie needs-setup=false et l'InstallGate laisse passer le reste du site.
 */

const Install = lazy(() => import("../pages/install/Install"));

export const installRoutes = <Route path="/install" element={<Install />} />;
